var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"burger-nav-button",attrs:{"src":require("../assets/menu-icons/Burger_menu.svg")},on:{"click":function($event){return _vm.toggleMenu()}}})}
var staticRenderFns = []

export { render, staticRenderFns }